import { render, staticRenderFns } from "./RmaRequest.vue?vue&type=template&id=241d2078&"
import script from "./RmaRequest.vue?vue&type=script&lang=js&"
export * from "./RmaRequest.vue?vue&type=script&lang=js&"
import style0 from "./RmaRequest.vue?vue&type=style&index=0&id=241d2078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports